import { render, staticRenderFns } from "./TableResponsive.vue?vue&type=template&id=0ecb8556&"
import script from "./TableResponsive.vue?vue&type=script&lang=js&"
export * from "./TableResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports